// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { Badge } from '@uswitch/spark'
import { TruCheckCircle } from '@uswitch/spark-icons/tru'
import { useDataSelector, useEntity } from '../helpers/selectors'
import SocialSharing from '../social-sharing'
import WrappedTrustyleAuthor from '../author/trustyle-author'

const ArticleIntro = ({ description, title, articleDetails }) => {
  const rootEntityFields = useDataSelector(['rootEntity', 'fields'])
  const { authors, editors, factChecked = false, publishDate, updatedDate } = rootEntityFields

  const authorEntity = useEntity(authors?.[0])
  const editorEntity = useEntity(editors?.[0])

  return (
    <div className='ArticleIntro'>
      <div className='ArticleIntro-row'>
        <h1>{title}</h1>
      </div>

      <div className='ArticleIntro-row'>
        <div className='ArticleIntro-content-col'>
          <WrappedTrustyleAuthor
            author={authorEntity}
            editor={editorEntity}
            publishDate={updatedDate || publishDate}
            showWrittenBy
          />
          {factChecked && (
            <Badge variant='success' leftIcon={<TruCheckCircle />} sx={{ mb: 'lg', mt: 'xs' }}>
              Fact Checked
            </Badge>
          )}
          {articleDetails && (
            <div className='ArticleIntro-row'>
              <p className='ArticleIntro-details'>{articleDetails}</p>
            </div>
          )}
          <p className='ArticleIntro-description'>{description}</p>
        </div>

        <div className='ArticleIntro-social-col'>
          <SocialSharing />
        </div>
      </div>
    </div>
  )
}

export default ArticleIntro
